module.exports = __webpack_public_path__ + "img/play.842462b3.png";